import { connect } from 'react-redux';

import { IAppState } from 'src/store';
import { Button, Form, Input, Text, View } from 'src/components/common';
import { Yup } from 'src/services';
import { Formik } from 'formik';
import appConfig from 'src/appConfig';
import { FORM_ERROR } from 'src/appConfig/constanst';

export type renameModalData = {
  title?: string | React.ReactNode;
  defaultValue?: string;
  okText?: string;
  cancelText?: string;
  onCancel?: (...arg: any[]) => void;
  onOk?: (...arg: any[]) => void;
};

type FileName = {
  name: string;
};

const RenameModal: React.FC<Props> = ({ modalData }) => {
  const {
    title,
    defaultValue,
    okText,
    cancelText,
    onOk = () => {},
    onCancel = () => {},
  } = modalData as renameModalData;
  const initial = {
    name: defaultValue || '',
  };
  const FileNameSchema = Yup.object().shape({
    name: Yup.string().required(FORM_ERROR.RequiredField).max(appConfig.TEXT_MAX_LENGTH, FORM_ERROR.TextMaxLength),
  });
  const handleOkClick = (values: FileName) => {
    onOk(values.name);
  };
  return (
    <View className={`ctn-modal__content`}>
      {title && (
        <Text className="mb-4 ctn-modal__content__title" size={20}>
          {title}
        </Text>
      )}
      <Formik initialValues={initial} onSubmit={handleOkClick} validationSchema={FileNameSchema}>
        {({ errors, touched, handleSubmit, getFieldProps }) => (
          <Form onSubmit={handleSubmit} autoComplete="off">
            <Input
              label=""
              placeholder="Type Here..."
              errorMessage={touched.name ? errors.name : ''}
              containerClassName="mb-5"
              {...getFieldProps('name')}
            />

            <View isRow justify="flex-end">
              <Button onClick={onCancel} type="button" variant="secondary-outline" className="mr-3">
                {cancelText || 'Cancel'}
              </Button>
              <Button type="submit" variant="secondary">
                {okText || 'OK'}
              </Button>
            </View>
          </Form>
        )}
      </Formik>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & {};

const mapStateToProps = (state: IAppState) => ({
  modalData: state.modal.data,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(RenameModal);
